export const journalTranslations = {
  en: {
    pageTitle: "Our Journals",
    pageSubtitle: "Explore our peer-reviewed open access international journals covering medical, engineering, natural, social, and interdisciplinary sciences.",
    viewJournal: "View Journal",
    submitPaper: "Submit Paper",
    journals: [
      {
        id: 1,
        title: "International Journal for research in Applied And Natural Science",
        description: "It is one of the best Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "/IJAN.jpeg",
        viewLink: "https://ijrans.com/index.php/ans",
        submitLink: "https://ijrans.com/index.php/ans"
      },
      {
        id: 2,
        title: "Kidneys Ukrainian Journal of Renal Medicine",
        description: "The professional scientific and practical specialized peer-reviewed journal for doctors treating patients with kidney disease and their complications, highlighting the advances in nephrology, urology.",
        image: "/cover-page.jpeg",
        viewLink: "https://kidneysjournal.com/index.php/journal",
        submitLink: "https://kidneysjournal.com/index.php/journal/about/submissions"
      },
      {
        id: 18,
        title: "African Journal of Biomedical Research (AJBR)",
        description: "The African Journal of Biomedical Research (AJBR) is a distinguished academic journal that has been at the forefront of scientific publishing in Africa since its inception in 1998.",
        image: "/AJBR.png",
        viewLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/index",
        submitLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/about/contact"
      },
      {
        id: 3,
        title: "ARC: Journal of AI in Clinical Practice",
        description: "ARC Journal of AI in Clinical Practice is a niche field of research that focuses on practical uses of AI, machine learning, and data-driven technologies in healthcare settings.",
        image: "/ARC.jpeg",
        viewLink: "https://arc-ai-clinical.com/index.php/arc",
        submitLink: "https://arc-ai-clinical.com/index.php/arc/about/submissions"
      },
      {
        id: 4,
        title: "International Journal for research in Biology & Pharmacy",
        description: "One of the best Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "/IJBP.png",
        viewLink: "https://ijrbp.com/index.php/bp",
        submitLink: "https://ijrbp.com/index.php/bp/about/submissions"
      },
      {
        id: 5,
        title: "International Journal for research in Advanced Computer Science And Engineering",
        description: "Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "IJAC.jpeg",
        viewLink: "https://ijracse.org/index.php/cse/index",
        submitLink: "https://ijracse.org/index.php/cse/about/submissions"
      },
      {
        id: 6,
        title: "International Journal for research in Educational Studies",
        description: "Bi-monthly, peer-reviewed, Open Access Journal. We have constantly changed the environment and the way we exchange knowledge. As a new scholarly publication platform, Green Publication has both, predicted and adapted to the challenges ahead.",
        image: "ijfres.png",
        viewLink: "https://ijfres.com/index.php/es",
        submitLink: "https://ijfres.com/index.php/es/about/submissions"
      },
      {
        id: 8,
        title: "International Journal for research in Mathematics And Statistics",
        description: "Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "IJRM.jpeg",
        viewLink: "https://ijfrms.com/index.php/ms",
        submitLink: "https://ijfrms.com/index.php/ms/about/submissions"
      },
      {
        id: 9,
        title: "International Journal for research in Health Sciences And Nursing",
        description: "Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "/IJHSN.jpeg",
        viewLink: "https://ijrhsn.com/index.php/hsn/index",
        submitLink: "https://ijrhsn.com/index.php/hsn/about/submissions"
      },
      {
        id: 10,
        title: "International Journal for research in Social Science And Humanities",
        description: "Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "IJSS.jpeg",
        viewLink: "https://ijfrssh.com/index.php/ssh",
        submitLink: "https://ijfrssh.com/index.php/ssh/about/submissions"
      },
      {
        id: 11,
        title: "International Journal for research in Electronics & Electrical Engineering",
        description: "Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "IJEE.jpeg",
        viewLink: "https://ijreee.com/index.php/eee",
        submitLink: "https://ijreee.com/index.php/eee/about/submissions"
      },
      {
        id: 12,
        title: "International Journal for research in Mechanical & Civil Engineering",
        description: "Open Access journals of Scholarly publishing that aims to publish the most complete and reliable source of information on discoveries and current developments.",
        image: "/IJMCE.jpeg",
        viewLink: "https://ijrmce.com/index.php/mce",
        submitLink: "https://ijrmce.com/index.php/mce/about/submissions"
      },
      {
        id: 15,
        title: "Medical Journal of Public Health",
        description: "Peer-reviewed, open-access academic journal with the objective to promote the research and professional practice in the fields of preventive medicine, population health sciences, and public health.",
        image: "/MJPH.png",
        viewLink: "https://mjphjournal.com/index.php/MJPH/",
        submitLink: "https://mjphjournal.com/index.php/MJPH/about/submissions"
      },
      {
        id: 16,
        title: "Journal of Pericardiology",
        description: "The Journal of Pericardiology (JOP) is an open-access peer-reviewed academic journal, that focuses on the promotion of knowledge in the field of pericardial science, cardiovascular medicine, and associated clinical studies.",
        image: "/JOP.png",
        viewLink: "https://jopjournal.com/",
        submitLink: "https://jopjournal.com/index.php/jop/about/submissions"
      }
    ]
  },

  hi: {
    pageTitle: "हमारे जर्नल्स",
    pageSubtitle: "चिकित्सा, इंजीनियरिंग, प्राकृतिक, सामाजिक और अंतरविषयक विज्ञानों को कवर करने वाली हमारी सहकर्मी-समीक्षित ओपन एक्सेस अंतरराष्ट्रीय पत्रिकाओं को देखें।",
    viewJournal: "जर्नल देखें",
    submitPaper: "पेपर जमा करें",
    journals: [
      {
        id: 1,
        title: "International Journal for research in Applied And Natural Science",
        description: "यह विद्वतापूर्ण प्रकाशन की सर्वश्रेष्ठ ओपन एक्सेस पत्रिकाओं में से एक है जिसका उद्देश्य खोजों और वर्तमान विकास पर सबसे पूर्ण और विश्वसनीय जानकारी प्रकाशित करना है।",
        image: "/IJAN.jpeg",
        viewLink: "https://ijrans.com/index.php/ans",
        submitLink: "https://ijrans.com/index.php/ans"
      },
      {
        id: 2,
        title: "Kidneys Ukrainian Journal of Renal Medicine",
        description: "गुर्दे की बीमारी और उनकी जटिलताओं का इलाज करने वाले डॉक्टरों के लिए पेशेवर सहकर्मी-समीक्षित पत्रिका, जो नेफ्रोलॉजी और यूरोलॉजी में प्रगति को रेखांकित करती है।",
        image: "/cover-page.jpeg",
        viewLink: "https://kidneysjournal.com/index.php/journal",
        submitLink: "https://kidneysjournal.com/index.php/journal/about/submissions"
      },
      {
        id: 18,
        title: "African Journal of Biomedical Research (AJBR)",
        description: "अफ्रीकन जर्नल ऑफ बायोमेडिकल रिसर्च (AJBR) एक प्रतिष्ठित अकादमिक पत्रिका है जो 1998 में अपनी स्थापना के बाद से अफ्रीका में वैज्ञानिक प्रकाशन में अग्रणी रही है।",
        image: "/AJBR.png",
        viewLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/index",
        submitLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/about/contact"
      },
      {
        id: 3,
        title: "ARC: Journal of AI in Clinical Practice",
        description: "एआरसी जर्नल ऑफ एआई इन क्लिनिकल प्रैक्टिस अनुसंधान का एक विशेष क्षेत्र है जो स्वास्थ्य सेवा में एआई, मशीन लर्निंग और डेटा-संचालित तकनीकों के व्यावहारिक उपयोग पर केंद्रित है।",
        image: "/ARC.jpeg",
        viewLink: "https://arc-ai-clinical.com/index.php/arc",
        submitLink: "https://arc-ai-clinical.com/index.php/arc/about/submissions"
      },
      {
        id: 4,
        title: "International Journal for research in Biology & Pharmacy",
        description: "विद्वतापूर्ण प्रकाशन की उत्कृष्ट ओपन एक्सेस पत्रिकाओं में से एक जिसका उद्देश्य जीव विज्ञान और फार्मेसी में खोजों पर सबसे विश्वसनीय जानकारी प्रकाशित करना है।",
        image: "/IJBP.png",
        viewLink: "https://ijrbp.com/index.php/bp",
        submitLink: "https://ijrbp.com/index.php/bp/about/submissions"
      },
      {
        id: 5,
        title: "International Journal for research in Advanced Computer Science And Engineering",
        description: "ओपन एक्सेस अंतरराष्ट्रीय शोध पत्रिका जो कंप्यूटर विज्ञान और इंजीनियरिंग में नवीनतम तकनीकी खोजों और विकास पर केंद्रित है।",
        image: "IJAC.jpeg",
        viewLink: "https://ijracse.org/index.php/cse/index",
        submitLink: "https://ijracse.org/index.php/cse/about/submissions"
      },
      {
        id: 6,
        title: "International Journal for research in Educational Studies",
        description: "द्वि-मासिक, सहकर्मी-समीक्षित, ओपन एक्सेस जर्नल। ज्ञान के आदान-प्रदान और शैक्षिक अनुसंधान की नई चुनौतियों के अनुकूल एक नवीन विद्वतापूर्ण मंच।",
        image: "ijfres.png",
        viewLink: "https://ijfres.com/index.php/es",
        submitLink: "https://ijfres.com/index.php/es/about/submissions"
      },
      {
        id: 8,
        title: "International Journal for research in Mathematics And Statistics",
        description: "गणित और सांख्यिकी में खोजों और वर्तमान विकास पर सबसे पूर्ण और विश्वसनीय जानकारी प्रकाशित करने के लिए समर्पित ओपन एक्सेस जर्नल।",
        image: "IJRM.jpeg",
        viewLink: "https://ijfrms.com/index.php/ms",
        submitLink: "https://ijfrms.com/index.php/ms/about/submissions"
      },
      {
        id: 9,
        title: "International Journal for research in Health Sciences And Nursing",
        description: "स्वास्थ्य विज्ञान और नर्सिंग के क्षेत्र में वैज्ञानिक प्रगति और शोध कार्यों के प्रसार को समर्पित ओपन एक्सेस सहकर्मी-समीक्षित पत्रिका।",
        image: "/IJHSN.jpeg",
        viewLink: "https://ijrhsn.com/index.php/hsn/index",
        submitLink: "https://ijrhsn.com/index.php/hsn/about/submissions"
      },
      {
        id: 10,
        title: "International Journal for research in Social Science And Humanities",
        description: "सामाजिक विज्ञान और मानविकी में अकादमिक विमर्श और नए विचारों के प्रसार को समर्पित अंतरराष्ट्रीय ओपन एक्सेस सहकर्मी-समीक्षित जर्नल।",
        image: "IJSS.jpeg",
        viewLink: "https://ijfrssh.com/index.php/ssh",
        submitLink: "https://ijfrssh.com/index.php/ssh/about/submissions"
      },
      {
        id: 11,
        title: "International Journal for research in Electronics & Electrical Engineering",
        description: "इलेक्ट्रॉनिक्स और इलेक्ट्रिकल इंजीनियरिंग में अभिनव समाधानों और तकनीकी प्रगति को बढ़ावा देने वाला ओपन एक्सेस जर्नल।",
        image: "IJEE.jpeg",
        viewLink: "https://ijreee.com/index.php/eee",
        submitLink: "https://ijreee.com/index.php/eee/about/submissions"
      },
      {
        id: 12,
        title: "International Journal for research in Mechanical & Civil Engineering",
        description: "मैकेनिकल और सिविल इंजीनियरिंग के अनुप्रयोगों, अनुसंधान और व्यावहारिक समस्याओं के समाधान पर केंद्रित अंतरराष्ट्रीय विद्वतापूर्ण जर्नल।",
        image: "/IJMCE.jpeg",
        viewLink: "https://ijrmce.com/index.php/mce",
        submitLink: "https://ijrmce.com/index.php/mce/about/submissions"
      },
      {
        id: 15,
        title: "Medical Journal of Public Health",
        description: "निवारक चिकित्सा, जनसंख्या स्वास्थ्य विज्ञान और सार्वजनिक स्वास्थ्य के क्षेत्रों में अनुसंधान और पेशेवर अभ्यास को बढ़ावा देने वाला सहकर्मी-समीक्षित अकादमिक जर्नल।",
        image: "/MJPH.png",
        viewLink: "https://mjphjournal.com/index.php/MJPH/",
        submitLink: "https://mjphjournal.com/index.php/MJPH/about/submissions"
      },
      {
        id: 16,
        title: "Journal of Pericardiology",
        description: "पेरीकार्डियोलॉजी (JOP) का जर्नल एक ओपन-एक्सेस सहकर्मी-समीक्षित अकादमिक जर्नल है जो पेरीकार्डियल विज्ञान और कार्डियोवैस्कुलर चिकित्सा में ज्ञान को बढ़ावा देता है।",
        image: "/JOP.png",
        viewLink: "https://jopjournal.com/",
        submitLink: "https://jopjournal.com/index.php/jop/about/submissions"
      }
    ]
  },

  es: {
    pageTitle: "Nuestras Revistas",
    pageSubtitle: "Explore nuestras revistas científicas internacionales de acceso abierto y revisadas por pares en ciencias médicas, ingeniería, naturales y sociales.",
    viewJournal: "Ver Revista",
    submitPaper: "Enviar Artículo",
    journals: [
      {
        id: 1,
        title: "International Journal for research in Applied And Natural Science",
        description: "Una de las mejores revistas de acceso abierto de publicaciones académicas para difundir información confiable sobre descubrimientos y desarrollos actuales.",
        image: "/IJAN.jpeg",
        viewLink: "https://ijrans.com/index.php/ans",
        submitLink: "https://ijrans.com/index.php/ans"
      },
      {
        id: 2,
        title: "Kidneys Ukrainian Journal of Renal Medicine",
        description: "Revista científica y especializada revisada por pares para médicos que tratan afecciones renales, destacando avances en nefrología y urología.",
        image: "/cover-page.jpeg",
        viewLink: "https://kidneysjournal.com/index.php/journal",
        submitLink: "https://kidneysjournal.com/index.php/journal/about/submissions"
      },
      {
        id: 18,
        title: "African Journal of Biomedical Research (AJBR)",
        description: "El African Journal of Biomedical Research (AJBR) es una distinguida revista académica pionera en la publicación científica en África desde 1998.",
        image: "/AJBR.png",
        viewLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/index",
        submitLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/about/contact"
      },
      {
        id: 3,
        title: "ARC: Journal of AI in Clinical Practice",
        description: "Revista especializada en la aplicación práctica de IA, aprendizaje automático y tecnologías basadas en datos en entornos de atención médica.",
        image: "/ARC.jpeg",
        viewLink: "https://arc-ai-clinical.com/index.php/arc",
        submitLink: "https://arc-ai-clinical.com/index.php/arc/about/submissions"
      },
      {
        id: 4,
        title: "International Journal for research in Biology & Pharmacy",
        description: "Revista de acceso abierto dedicada a publicar fuentes fiables de información sobre descubrimientos y desarrollos en biología y farmacia.",
        image: "/IJBP.png",
        viewLink: "https://ijrbp.com/index.php/bp",
        submitLink: "https://ijrbp.com/index.php/bp/about/submissions"
      },
      {
        id: 5,
        title: "International Journal for research in Advanced Computer Science And Engineering",
        description: "Revista científica de acceso abierto que difunde avances de vanguardia en ciencias de la computación e ingeniería.",
        image: "IJAC.jpeg",
        viewLink: "https://ijracse.org/index.php/cse/index",
        submitLink: "https://ijracse.org/index.php/cse/about/submissions"
      },
      {
        id: 6,
        title: "International Journal for research in Educational Studies",
        description: "Revista bimestral, con revisión por pares y de acceso abierto dedicada a la investigación pedagógica y metodologías de enseñanza.",
        image: "ijfres.png",
        viewLink: "https://ijfres.com/index.php/es",
        submitLink: "https://ijfres.com/index.php/es/about/submissions"
      },
      {
        id: 8,
        title: "International Journal for research in Mathematics And Statistics",
        description: "Revista de acceso abierto que publica desarrollos y descubrimientos rigurosos en matemáticas puras, aplicadas y estadística.",
        image: "IJRM.jpeg",
        viewLink: "https://ijfrms.com/index.php/ms",
        submitLink: "https://ijfrms.com/index.php/ms/about/submissions"
      },
      {
        id: 9,
        title: "International Journal for research in Health Sciences And Nursing",
        description: "Revista académica de acceso abierto dedicada a la investigación en ciencias de la salud, enfermería y atención médica integral.",
        image: "/IJHSN.jpeg",
        viewLink: "https://ijrhsn.com/index.php/hsn/index",
        submitLink: "https://ijrhsn.com/index.php/hsn/about/submissions"
      },
      {
        id: 10,
        title: "International Journal for research in Social Science And Humanities",
        description: "Revista dedicada a la difusión del conocimiento y diálogo académico en ciencias sociales, cultura y humanidades.",
        image: "IJSS.jpeg",
        viewLink: "https://ijfrssh.com/index.php/ssh",
        submitLink: "https://ijfrssh.com/index.php/ssh/about/submissions"
      },
      {
        id: 11,
        title: "International Journal for research in Electronics & Electrical Engineering",
        description: "Revista de investigación sobre avances técnicos y metodologías en ingeniería electrónica y eléctrica.",
        image: "IJEE.jpeg",
        viewLink: "https://ijreee.com/index.php/eee",
        submitLink: "https://ijreee.com/index.php/eee/about/submissions"
      },
      {
        id: 12,
        title: "International Journal for research in Mechanical & Civil Engineering",
        description: "Publicación de acceso abierto dedicada a investigaciones teóricas y empíricas en ingeniería mecánica y obras civiles.",
        image: "/IJMCE.jpeg",
        viewLink: "https://ijrmce.com/index.php/mce",
        submitLink: "https://ijrmce.com/index.php/mce/about/submissions"
      },
      {
        id: 15,
        title: "Medical Journal of Public Health",
        description: "Revista académica con revisión por pares que promueve la investigación y práctica en medicina preventiva y salud pública.",
        image: "/MJPH.png",
        viewLink: "https://mjphjournal.com/index.php/MJPH/",
        submitLink: "https://mjphjournal.com/index.php/MJPH/about/submissions"
      },
      {
        id: 16,
        title: "Journal of Pericardiology",
        description: "Revista de acceso abierto centrada en la ciencia pericárdica, medicina cardiovascular y estudios clínicos relacionados.",
        image: "/JOP.png",
        viewLink: "https://jopjournal.com/",
        submitLink: "https://jopjournal.com/index.php/jop/about/submissions"
      }
    ]
  },

  ta: {
    pageTitle: "எங்கள் ஆராய்ச்சி இதழ்கள்",
    pageSubtitle: "மருத்துவம், பொறியியல், இயற்கை, சமூக அறிவியல் மற்றும் இடைநிலைத் துறைகளை உள்ளடக்கிய எங்கள் சர்வதேச சக மதிப்பாய்வு திறந்த அணுகல் இதழ்களைக் கண்டறியுங்கள்.",
    viewJournal: "இதழைப் பார்க்க",
    submitPaper: "ஆய்வை சமர்ப்பிக்க",
    journals: [
      {
        id: 1,
        title: "International Journal for research in Applied And Natural Science",
        description: "அறிவியல் கண்டுபிடிப்புகள் மற்றும் தற்போதைய முன்னேற்றங்கள் பற்றிய முழுமையான மற்றும் நம்பகமான தகவல்களை வெளியிடும் சிறந்த திறந்த அணுகல் கல்வி இதழ்.",
        image: "/IJAN.jpeg",
        viewLink: "https://ijrans.com/index.php/ans",
        submitLink: "https://ijrans.com/index.php/ans"
      },
      {
        id: 2,
        title: "Kidneys Ukrainian Journal of Renal Medicine",
        description: "சிறுநீரக நோய்கள் மற்றும் அதனுடன் தொடர்புடைய சிக்கல்களுக்கு சிகிச்சையளிக்கும் மருத்துவர்களுக்கான சிறப்பு சக மதிப்பாய்வு செய்யப்பட்ட இதழ்.",
        image: "/cover-page.jpeg",
        viewLink: "https://kidneysjournal.com/index.php/journal",
        submitLink: "https://kidneysjournal.com/index.php/journal/about/submissions"
      },
      {
        id: 18,
        title: "African Journal of Biomedical Research (AJBR)",
        description: "ஆப்பிரிக்க பயோமெடிக்கல் ஆராய்ச்சி இதழ் (AJBR) 1998 இல் தொடங்கப்பட்டதிலிருந்து ஆப்பிரிக்காவில் அறிவியல் வெளியீட்டில் முன்னணியில் உள்ள ஒரு புகழ்பெற்ற கல்வி இதழ்.",
        image: "/AJBR.png",
        viewLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/index",
        submitLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/about/contact"
      },
      {
        id: 3,
        title: "ARC: Journal of AI in Clinical Practice",
        description: "மருத்துவ சூழலில் செயற்கை நுண்ணறிவு (AI), இயந்திர கற்றல் மற்றும் தரவு சார்ந்த தொழில்நுட்பங்களின் பயன்பாடுகளில் கவனம் செலுத்தும் பிரத்யேக இதழ்.",
        image: "/ARC.jpeg",
        viewLink: "https://arc-ai-clinical.com/index.php/arc",
        submitLink: "https://arc-ai-clinical.com/index.php/arc/about/submissions"
      },
      {
        id: 4,
        title: "International Journal for research in Biology & Pharmacy",
        description: "உயிரியல் மற்றும் மருந்தியல் கண்டுபிடிப்புகளில் நம்பகமான ஆராய்ச்சிகளை வெளியிடும் சிறந்த திறந்த அணுகல் கல்வி இதழ்.",
        image: "/IJBP.png",
        viewLink: "https://ijrbp.com/index.php/bp",
        submitLink: "https://ijrbp.com/index.php/bp/about/submissions"
      },
      {
        id: 5,
        title: "International Journal for research in Advanced Computer Science And Engineering",
        description: "கணினி அறிவியல் மற்றும் பொறியியல் துறையில் அதிநவீன கண்டுபிடிப்புகள் மற்றும் ஆராய்ச்சிகளை வெளியிடும் திறந்த அணுகல் இதழ்.",
        image: "IJAC.jpeg",
        viewLink: "https://ijracse.org/index.php/cse/index",
        submitLink: "https://ijracse.org/index.php/cse/about/submissions"
      },
      {
        id: 6,
        title: "International Journal for research in Educational Studies",
        description: "இரு மாதங்களுக்கு ஒருமுறை வெளியாகும் சக மதிப்பாய்வு செய்யப்பட்ட திறந்த அணுகல் கல்வி இதழ். கல்வி ஆராய்ச்சியில் புதிய சிந்தனைகளை ஊக்குவிக்கிறது.",
        image: "ijfres.png",
        viewLink: "https://ijfres.com/index.php/es",
        submitLink: "https://ijfres.com/index.php/es/about/submissions"
      },
      {
        id: 8,
        title: "International Journal for research in Mathematics And Statistics",
        description: "கணிதம் மற்றும் புள்ளியியல் துறையில் புதிய கண்டுபிடிப்புகள் மற்றும் தற்போதைய முன்னேற்றங்களை வெளியிடும் கல்வி இதழ்.",
        image: "IJRM.jpeg",
        viewLink: "https://ijfrms.com/index.php/ms",
        submitLink: "https://ijfrms.com/index.php/ms/about/submissions"
      },
      {
        id: 9,
        title: "International Journal for research in Health Sciences And Nursing",
        description: "சுகாதார அறிவியல் மற்றும் நர்சிங் துறையில் தரமான ஆராய்ச்சிகளை வெளியிடும் சர்வதேச திறந்த அணுகல் கல்வி இதழ்.",
        image: "/IJHSN.jpeg",
        viewLink: "https://ijrhsn.com/index.php/hsn/index",
        submitLink: "https://ijrhsn.com/index.php/hsn/about/submissions"
      },
      {
        id: 10,
        title: "International Journal for research in Social Science And Humanities",
        description: "சமூக அறிவியல் மற்றும் மானுடவியல் துறைகளில் கல்வி உரையாடல் மற்றும் புதிய ஆராய்ச்சிகளை ஊக்குவிக்கும் திறந்த அணுகல் இதழ்.",
        image: "IJSS.jpeg",
        viewLink: "https://ijfrssh.com/index.php/ssh",
        submitLink: "https://ijfrssh.com/index.php/ssh/about/submissions"
      },
      {
        id: 11,
        title: "International Journal for research in Electronics & Electrical Engineering",
        description: "எலக்ட்ரானிக்ஸ் மற்றும் எலக்ட்ரிக்கல் இன்ஜினியரிங் துறையில் தொழில்நுட்ப முன்னேற்றங்களை வெளியிடும் சர்வதேச இதழ்.",
        image: "IJEE.jpeg",
        viewLink: "https://ijreee.com/index.php/eee",
        submitLink: "https://ijreee.com/index.php/eee/about/submissions"
      },
      {
        id: 12,
        title: "International Journal for research in Mechanical & Civil Engineering",
        description: "மெக்கானிக்கல் மற்றும் சிவில் இன்ஜினியரிங் நடைமுறை பயன்பாடுகள் மற்றும் ஆராய்ச்சிகளில் கவனம் செலுத்தும் சர்வதேச கல்வி இதழ்.",
        image: "/IJMCE.jpeg",
        viewLink: "https://ijrmce.com/index.php/mce",
        submitLink: "https://ijrmce.com/index.php/mce/about/submissions"
      },
      {
        id: 15,
        title: "Medical Journal of Public Health",
        description: "தடுப்பு மருத்துவம், மக்கள் தொகை சுகாதார அறிவியல் மற்றும் பொது சுகாதாரம் ஆகிய துறைகளில் ஆராய்ச்சியை ஊக்குவிக்கும் சக மதிப்பாய்வு இதழ்.",
        image: "/MJPH.png",
        viewLink: "https://mjphjournal.com/index.php/MJPH/",
        submitLink: "https://mjphjournal.com/index.php/MJPH/about/submissions"
      },
      {
        id: 16,
        title: "Journal of Pericardiology",
        description: "பெரிகார்டியல் அறிவியல், இதய மருத்துவம் மற்றும் மருத்துவ ஆய்வுகள் ஆகியவற்றில் ஆராய்ச்சியை மேம்படுத்தும் திறந்த அணுகல் கல்வி இதழ்.",
        image: "/JOP.png",
        viewLink: "https://jopjournal.com/",
        submitLink: "https://jopjournal.com/index.php/jop/about/submissions"
      }
    ]
  },

  te: {
    pageTitle: "మా జర్నల్స్",
    pageSubtitle: "వైద్య, ఇంజనీరింగ్, సహజ, సామాజిక మరియు అంతరశాఖా శాస్త్రాలను కవర్ చేసే మా పీర్-రివ్యూడ్ ఓపెన్ యాక్సెస్ అంతర్జాతీయ జర్నల్స్‌ను అన్వేషించండి.",
    viewJournal: "జర్నల్‌ను చూడండి",
    submitPaper: "పేపర్‌ను సమర్పించండి",
    journals: [
      {
        id: 1,
        title: "International Journal for research in Applied And Natural Science",
        description: "ఆవిష్కరణలు మరియు తాజా పురోగతులపై అత్యంత సంపూర్ణమైన మరియు విశ్వసనీయమైన సమాచారాన్ని ప్రచురించే ఉత్తమ ఓపెన్ యాక్సెస్ జర్నల్.",
        image: "/IJAN.jpeg",
        viewLink: "https://ijrans.com/index.php/ans",
        submitLink: "https://ijrans.com/index.php/ans"
      },
      {
        id: 2,
        title: "Kidneys Ukrainian Journal of Renal Medicine",
        description: "కిడ్నీ వ్యాధులతో బాధపడుతున్న రోగులకు చికిత్స చేసే వైద్యుల కోసం నెఫ్రాలజీ, యూరాలజీలో పురోగతిని తెలిపే ప్రత్యేక పీర్-రివ్యూడ్ జర్నల్.",
        image: "/cover-page.jpeg",
        viewLink: "https://kidneysjournal.com/index.php/journal",
        submitLink: "https://kidneysjournal.com/index.php/journal/about/submissions"
      },
      {
        id: 18,
        title: "African Journal of Biomedical Research (AJBR)",
        description: "ఆఫ్రికన్ జర్నల్ ఆఫ్ బయోమెడికల్ రీసెర్చ్ (AJBR) 1998లో స్థాపించబడినప్పటి నుండి ఆఫ్రికాలో శాస్త్రీయ ప్రచురణలో ప్రముఖ స్థానంలో ఉన్న విద్యా జర్నల్.",
        image: "/AJBR.png",
        viewLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/index",
        submitLink: "https://africanjournalofbiomedicalresearch.com/index.php/AJBR/about/contact"
      },
      {
        id: 3,
        title: "ARC: Journal of AI in Clinical Practice",
        description: "ఆరోగ్య సంరక్షణలో AI, మెషిన్ లెర్నింగ్ మరియు డేటా-ఆధారిత సాంకేతికతల ఆచరణాత్మక ఉపయోగాలపై దృష్టి సారించే ప్రత్యేక పరిశోధనా జర్నల్.",
        image: "/ARC.jpeg",
        viewLink: "https://arc-ai-clinical.com/index.php/arc",
        submitLink: "https://arc-ai-clinical.com/index.php/arc/about/submissions"
      },
      {
        id: 4,
        title: "International Journal for research in Biology & Pharmacy",
        description: "జీవశాస్త్రం మరియు ఫార్మసీలో ఆవిష్కరణలు మరియు నూతన అభివృద్ధిపై విశ్వసనీయ సమాచారాన్ని ప్రచురించే ఓపెన్ యాక్సెస్ జర్నల్.",
        image: "/IJBP.png",
        viewLink: "https://ijrbp.com/index.php/bp",
        submitLink: "https://ijrbp.com/index.php/bp/about/submissions"
      },
      {
        id: 5,
        title: "International Journal for research in Advanced Computer Science And Engineering",
        description: "కంప్యూటర్ సైన్స్ మరియు ఇంజనీరింగ్‌లో అధునాతన ఆవిష్కరణలు మరియు సాంకేతిక పరిశోధనలను ప్రచురించే ఓపెన్ యాక్సెస్ జర్నల్.",
        image: "IJAC.jpeg",
        viewLink: "https://ijracse.org/index.php/cse/index",
        submitLink: "https://ijracse.org/index.php/cse/about/submissions"
      },
      {
        id: 6,
        title: "International Journal for research in Educational Studies",
        description: "ద్వైమాసిక, పీర్-రివ్యూడ్ ఓపెన్ యాక్సెస్ జర్నల్. విద్యా రంగంలో సరికొత్త సవాళ్లు మరియు జ్ఞాన మార్పిడికి అనుకూలమైన వేదిక.",
        image: "ijfres.png",
        viewLink: "https://ijfres.com/index.php/es",
        submitLink: "https://ijfres.com/index.php/es/about/submissions"
      },
      {
        id: 8,
        title: "International Journal for research in Mathematics And Statistics",
        description: "గణితం మరియు గణాంక శాస్త్రంలో ఆవిష్కరణలు మరియు పరిశోధనలను ప్రచురించడానికి అంకితమైన అంతర్జాతీయ జర్నల్.",
        image: "IJRM.jpeg",
        viewLink: "https://ijfrms.com/index.php/ms",
        submitLink: "https://ijfrms.com/index.php/ms/about/submissions"
      },
      {
        id: 9,
        title: "International Journal for research in Health Sciences And Nursing",
        description: "ఆరోగ్య శాస్త్రాలు మరియు నర్సింగ్ రంగంలో నూతన శాస్త్రీయ పురోగతులను అందించే ఓపెన్ యాక్సెస్ విద్యా జర్నల్.",
        image: "/IJHSN.jpeg",
        viewLink: "https://ijrhsn.com/index.php/hsn/index",
        submitLink: "https://ijrhsn.com/index.php/hsn/about/submissions"
      },
      {
        id: 10,
        title: "International Journal for research in Social Science And Humanities",
        description: "సామాజిక శాస్త్రాలు మరియు మానవీయ శాస్త్రాలలో విద్యా పరిశోధన మరియు కొత్త ఆలోచనలను ప్రోత్సహించే అంతర్జాతీయ జర్నల్.",
        image: "IJSS.jpeg",
        viewLink: "https://ijfrssh.com/index.php/ssh",
        submitLink: "https://ijfrssh.com/index.php/ssh/about/submissions"
      },
      {
        id: 11,
        title: "International Journal for research in Electronics & Electrical Engineering",
        description: "ఎలక్ట్రానిక్స్ మరియు ఎలక్ట్రికల్ ఇంజనీరింగ్ రంగంలో తాజా సాంకేతిక పరిజ్ఞానం మరియు పరిశోధనలను ప్రచురించే జర్నల్.",
        image: "IJEE.jpeg",
        viewLink: "https://ijreee.com/index.php/eee",
        submitLink: "https://ijreee.com/index.php/eee/about/submissions"
      },
      {
        id: 12,
        title: "International Journal for research in Mechanical & Civil Engineering",
        description: "మెకానికల్ మరియు సివిల్ ఇంజనీరింగ్ యొక్క ఆచరణాత్మక పరిష్కారాలు మరియు పరిశోధనలపై దృష్టి సారించే జర్నల్.",
        image: "/IJMCE.jpeg",
        viewLink: "https://ijrmce.com/index.php/mce",
        submitLink: "https://ijrmce.com/index.php/mce/about/submissions"
      },
      {
        id: 15,
        title: "Medical Journal of Public Health",
        description: "నివారణ వైద్యం, ప్రజారోగ్య శాస్త్రాలు మరియు ప్రజారోగ్య రంగాలలో పరిశోధన మరియు వృత్తిపరమైన ఆచరణను ప్రోత్సహించే పీర్-రివ్యూడ్ జర్నల్.",
        image: "/MJPH.png",
        viewLink: "https://mjphjournal.com/index.php/MJPH/",
        submitLink: "https://mjphjournal.com/index.php/MJPH/about/submissions"
      },
      {
        id: 16,
        title: "Journal of Pericardiology",
        description: "పెరికార్డియల్ సైన్స్, కార్డియోవాస్కులర్ మెడిసిన్ మరియు సంబంధిత క్లినికల్ అధ్యయనాల రంగంలో జ్ఞానాన్ని ప్రోత్సహించే ఓపెన్ యాక్సెస్ జర్నల్.",
        image: "/JOP.png",
        viewLink: "https://jopjournal.com/",
        submitLink: "https://jopjournal.com/index.php/jop/about/submissions"
      }
    ]
  }
};
